// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__305Ia","actions":"GroupTable_actions__1o9gt","deleteModalFooter":"GroupTable_deleteModalFooter__3ORvx"};